import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export function NotFound() {
  return (
    <div className="h-full grid place-items-center p-6">
      <div className="text-center space-y-3">
        <div className="text-6xl font-bold text-ink-faint">404</div>
        <p className="text-ink-dim">That page does not exist.</p>
        <Button asChild>
          <Link to="/">Take me home</Link>
        </Button>
      </div>
    </div>
  );
}
